import {observer} from 'mobx-react-lite'
import * as React from 'react'
import {Lang} from 'yougile-lang'
import {LinkButton} from '@components/common/base/buttons'
import {useBoardAppearanceStore} from './board-appearance-store'
import {TwListItemButton, TwSkinsContainer} from './containers'
import {OurSkinItem} from './our-skin-item'

export const OurSkins = observer(() => {
  const [state, store] = useBoardAppearanceStore()

  return (
    <TwSkinsContainer>
      {store.skins?.map(skin => (
        <OurSkinItem key={skin.path} skin={skin.path} custom={skin.custom} />
      ))}

      {!state.tabBgShowMore && (
        <TwListItemButton>
          <LinkButton onClick={() => store.tabBgShowMore()} noPaddings>
            <div>{Lang.msg.showMore31}</div>
            <div>{Lang.msg.showMore32}…</div>
          </LinkButton>
        </TwListItemButton>
      )}
    </TwSkinsContainer>
  )
})
